import {i18n} from '@/plugins/i18next';

let reasonList = [];
reasonList.push({code: 'COULD_NOT_FIX', label: i18n.t('book/issue:reasons.COULD_NOT_FIX')});
reasonList.push({code: 'DUPLICATE', label: i18n.t('book/issue:reasons.DUPLICATE')});
reasonList.push({code: 'IS_ALREADY_FIXED', label: i18n.t('book/issue:reasons.IS_ALREADY_FIXED')});

export default reasonList;